<template>
    <v-data-table
      :headers="headers"
      :items="reverseNetworks"
      :items-per-page="5"
      class="elevation-1 ma-2"
    >
      <template v-slot:item.timestamp="{ item }">
        <span>
          {{ new Date(item.timestamp).toLocaleString('en-GB', { timeZone: 'Europe/Helsinki' })}}
          </span>
      </template>
    </v-data-table>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_NETWORK_STATUS = gql`
query query_network_status($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  network_status (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    timestamp
    available
    connected
    type
  }
}
`;
const SUBSCRIPTION_NETWORK_STATUS = gql`
subscription subscription_network_status($id: String!, $timestamp: timestamptz) {
  network_status (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    timestamp
    available
    connected
    type
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      networks: [],
      headers: [
        { text: 'Time', align: 'start', sortable: true, value: 'timestamp' },
        { text: 'Available', value: 'available' },
        { text: 'Connected', value: 'connected' },
        { text: 'Type', value: 'type' },
      ],
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  computed: {
    reverseNetworks() {
      return this.networks.reverse();
    },
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
  },
  beforeDestroy() {
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    await this.getNetworks();
    this.subcribeNewNetworks();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for battery values
      await this.getNetworks();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getNetworks() {
      const result = await this.$apollo.query({
        query: QUERY_NETWORK_STATUS,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.networks = result.data.network_status;
    },
    subcribeNewNetworks() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new cpu values
      this.$apollo.subscribe({
        query: SUBSCRIPTION_NETWORK_STATUS,
        variables: {
          id,
          timestamp
        },
      }).subscribe({
          next(data) {
            // got new subscription result
            if (data.data.network_status.length > 0) {
              // Add new cpu value to chart
              const [temp] = data.data.network_status;
              that.networks.push(temp);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
  },
};
</script>
<style scoped>
</style>
